import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DialogComponent } from "../../common/DialogComponent";
import IDFFamilyServiceDialog from "../../Dialogs/IDFFamilyServiceDialog";
import ResendActivationMailDialog from "../../Dialogs/ResendActivationMailDialog";
import DeleteFamilyAccountDialog from "../../Dialogs/DeleteFamilyAccountDialog";
import { ApplicationState } from "../../../store";
import * as LoginActions from "../../../store/loginService/actions";
import * as LoginTypes from "../../../store/loginService/types";
import * as services from "../../../store/service";
import moment from "moment-timezone";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
const IDFFamilyProtection: React.FunctionComponent<{ openAddFamilyProtectionDialog(): void; history: any }> = (props) => {
    const dispatch = useDispatch();
    const { t: tLang, i18n: i18nLang } = useTranslation()
    const familyMembers = useSelector((state: ApplicationState) => {
        const familyMembers = state.loggedInUser && state.loggedInUser.familyMembers ? state.loggedInUser.familyMembers : [];
        let switchAbleAccounts = familyMembers.filter(
            (familyAccount) => familyAccount.accountType && (familyAccount.accountType.includes("child") || familyAccount.accountType.includes("PRIMARY"))
        );
        let notSwitchAbleAccounts = familyMembers.filter(
            (familyAccount) => familyAccount.accountType && !(familyAccount.accountType.includes("child") || familyAccount.accountType.includes("PRIMARY"))
        );
        switchAbleAccounts.sort((memberX, memberY) =>
            memberX.firstName &&
            memberX.lastName &&
            memberY.firstName &&
            memberY.lastName &&
            memberX.firstName.toLocaleLowerCase() + memberX.lastName.toLocaleLowerCase() >
                memberY.firstName.toLocaleLowerCase() + memberY.lastName.toLocaleLowerCase()
                ? 1
                : -1
        );
        notSwitchAbleAccounts.sort((memberX, memberY) =>
            memberX.firstName &&
            memberX.lastName &&
            memberY.firstName &&
            memberY.lastName &&
            memberX.firstName.toLocaleLowerCase() + memberX.lastName.toLocaleLowerCase() >
                memberY.firstName.toLocaleLowerCase() + memberY.lastName.toLocaleLowerCase()
                ? 1
                : -1
        );
        let sortedMemberList = new Array();
        sortedMemberList.push(...switchAbleAccounts);
        sortedMemberList.push(...notSwitchAbleAccounts);
        return sortedMemberList;
    });
    const setChildSubCustomerIDToCompleteAccoutSetup = (subCustomerID: string) =>
        dispatch(LoginActions.actionCreators.setChildSubCustomerIDToCompleteAccountSetup(subCustomerID));
    const [loading, setLoading] = useState(false);
    const isServiceActive = (serviceDisplayName: string, state: ApplicationState) => {
        const services =
            state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.userServices
                ? state.loggedInUser && state.loggedInUser.userServiceDetails.userServices
                : [];
        const selectedService = services.find((service) => service.displayName === serviceDisplayName);
        if (selectedService && selectedService.active) {
            return true;
        }
        return false;
    };
    const switchFamilyAccount = (activeAccount: LoginTypes.IUserFamilyAccountInfo, familyMembers: LoginTypes.IUserFamilyAccountInfo[]) =>
        dispatch(LoginActions.actionCreators.switchFamilyAccount(activeAccount, props.history, familyMembers));
    const [removeAccountSubcustomerID, setRemoveAccountSubcustomerID] = useState("");
    const isIDFFamilyServiceActive = useSelector((state: ApplicationState) => isServiceActive("Family", state));
    const isIDFFamilyChildActive = useSelector((state: ApplicationState) => isServiceActive("Family 3.0 Child", state));
    const isIDFFamilySpouseActive = useSelector((state: ApplicationState) => isServiceActive("Family 3.0 Spouse", state));
    const hasIDFFamilyService = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.hasFamilyService ? state.loggedInUser.hasFamilyService : false
    );
    const csidUserStatus = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.csidUserStatus ? state.csidUserStatusState.csidUserStatus : null
    );
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const userCountry = useSelector((state: ApplicationState) =>
        state.myAccountServiceState?._unifiedAccountInfo?.country
    );
    const countryRequiresAuthentication = useSelector((state: ApplicationState) => {
        return ['US', 'CA'].includes(userCountry || '');
    });
    const isFamilyProtectionServiceActive = hasIDFFamilyService && (isIDFFamilyServiceActive || isIDFFamilyChildActive || isIDFFamilySpouseActive);
    const [isIDFFamilyServiceDialogVisible, setIDFFamilyServiceDialogIsVisible] = useState(false);
    const [isResendActivationMailDialogVisible, setResendActivationMailDialogVisible] = useState(false);
    const [isRemoveAccountDialogVisible, setRemoveAccountDialogVisible] = useState(false);
    const [resendActivationEmailAccountDetails, setResendActivationEmailDetails] = useState({ firstName: "", lastName: "", email: "", subcustomerId: "" });
    const notSwitchAbleAccounts = familyMembers.filter(
        (familyAccount) => familyAccount.accountType && !(familyAccount.accountType.includes("child") || familyAccount.accountType.includes("PRIMARY"))
    );
    const showAddFamilyLink = isIDFFamilyServiceActive || isIDFFamilyChildActive ? true : isIDFFamilySpouseActive ? notSwitchAbleAccounts.length <= 0 : false;
    const isAuthenticated = csidUserStatus?.["auth-status"]?.toLocaleLowerCase() === "authenticated";
    const history = useHistory();

    const openRemoveDialog = (): any => {
        setRemoveAccountDialogVisible(true);
    };

    const closeRemoveDialog = (): any => {
        setRemoveAccountDialogVisible(false);
    };

    const openAddFamilyMemberDialog = (): any => {
        setIDFFamilyServiceDialogIsVisible(true);
    };

    const closeFamilyMemberDialog = (): any => {
        setIDFFamilyServiceDialogIsVisible(false);
    };

    const openResendActivationMailDialog = (): any => {
        setResendActivationMailDialogVisible(true);
    };

    const closeResendActivationMailDialog = (): any => {
        setResendActivationMailDialogVisible(false);
    };

    const removeAccount = (subCustomerId: string) => {
        setRemoveAccountSubcustomerID(subCustomerId);
        openRemoveDialog();
    };

    const generateResendActivationEmailLink = (member: any) => {
        if (member.cancelDate || member.registrationStatus) {
            return <React.Fragment></React.Fragment>;
        }
        return (
            <a
                href="javascript:void(0);"
                onClick={() => {
                    setResendActivationEmailDetails({
                        ...resendActivationEmailAccountDetails,
                        firstName: member.firstName ? member.firstName : "",
                        lastName: member.lastName ? member.lastName : "",
                        email: member.email ? member.email : "",
                        subcustomerId: member.subcustomerId ? member.subcustomerId : "",
                    });
                    openResendActivationMailDialog();
                }}
                className="default_link"
            >
                <div className="data-value">Resend Activation Email</div>
            </a>
        );
    };

    const switchUserAccount = (subcustomerID: string) => {
        const accountToSwitch = familyMembers.find((x) => x.subcustomerId === subcustomerID);

        const requestBody = {
            childAccountID: accountToSwitch && accountToSwitch.userId ? accountToSwitch.userId : " ",
        };
        setLoading(true);
        services
            .checkCompleteAccountSetup(requestBody)
            .then((data) => {
                if (data.isAccountSetupCompleted) {
                    const requestBody = { SubcustomerId: subcustomerID };

                    services
                        .switchFamilyAccount(requestBody)
                        .then((data) => {
                            setLoading(false);
                            if (!data["hasError"] && data["familyMembers"]) {
                                if (accountToSwitch) {
                                    switchFamilyAccount(accountToSwitch, data["familyMembers"]);
                                }
                            }
                        })
                        .catch(() => {
                            setLoading(false);
                        });
                } else {
                    setLoading(false);
                    if (accountToSwitch) {
                        setChildSubCustomerIDToCompleteAccoutSetup(subcustomerID);
                        props.history.push("/complete-family-setup");
                    }
                }
            })
            .catch(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        setTimeout(() => {
            if (history.location.hash.includes("#family-protection")) {
                document.getElementById("family-protection") &&
                    document.getElementById("family-protection")!.scrollIntoView({ block: "center", behavior: "smooth" });
            }
        }, 1000);
    }, [isFamilyProtectionServiceActive]);

    return (
        <React.Fragment>
            {isFamilyProtectionServiceActive ? (
                <div className={loading ? "box offset-padding loading" : "box offset-padding"} id="family-protection">
                    <div className="box-header">
                        <div className="box-title-container">
                            <div className="box-title-icon" aria-hidden="true">
                                <RenderIcons iconName="users" />
                            </div>
                            <div className="box-title-text has-actions">
                                <h2 className="box-title">{tLang("manageAccount.myAccount.familyProtection.title")}</h2>
                            </div>
                        </div>
                    </div>
                    {showAddFamilyLink && !isAuthenticated && countryRequiresAuthentication && (
                        <div>
                            <div className="dialog-header">
                                <h2>
                                    <span className="dialog-icon status-default">
                                        <em className="las la-exclamation-triangle"></em>
                                    </span>
                                    &nbsp;{tLang("dashboard.addFamilyMemberDialog.childwatch.identityVerificationMessageTitle")}
                                </h2>
                            </div>
                            <div className="dialog-body">
                                <p>{tLang("dashboard.addFamilyMemberDialog.childwatch.identityVerificationMessage1")}</p>
                                <p>
                                    {tLang("dashboard.addFamilyMemberDialog.childwatch.identityVerificationMessage2")}{" "}
                                    <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber} </a>{" "}
                                    {tLang("dashboard.addFamilyMemberDialog.childwatch.identityVerificationMessage3")}
                                </p>
                            </div>

                        </div>
                    )}
                    <div className="box-content">
                        <div role="grid" className="data-grid " id="user-grid" aria-hidden="false">
                            {familyMembers.map((member) => {
                                const accountType = member.accountType ? member.accountType.toLowerCase() : "";
                                let isAccountCouldBeSwitch = accountType.includes("child") || accountType.includes("primary") ? true : false;
                                if (!member.registrationStatus) {
                                    isAccountCouldBeSwitch = false;
                                }

                                const subcustomerID = member.subcustomerId ? member.subcustomerId : "";

                                return (
                                    <div role="row" key={subcustomerID} className="data-row row between-xs between-sm">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label">
                                                <em
                                                    className={isAccountCouldBeSwitch ? "las la-user-circle" : "las la-lock"}
                                                    style={{ fontSize: "1.25rem", lineHeight: "1.5rem", verticalAlign: "top" }}
                                                ></em>
                                                {" " + member.firstName + " " + member.lastName}
                                            </div>
                                        </div>
                                        {isAccountCouldBeSwitch && (
                                            <div role="gridcell" className="col-xs-6 col-sm-4 col-no-gutter">
                                                <a
                                                    href="javascript:void(0);"
                                                    onClick={() => {
                                                        switchUserAccount(subcustomerID);
                                                    }}
                                                    className="default_link"
                                                >
                                                    <div className="data-value">Switch Account</div>
                                                </a>
                                            </div>
                                        )}
                                        {!isAccountCouldBeSwitch && (
                                            <div role="gridcell" className="col-xs-6 col-sm-4 col-no-gutter">
                                                {generateResendActivationEmailLink(member)}
                                            </div>
                                        )}
                                        {!member.cancelDate && (
                                            <div role="gridcell" className="col-xs-6 col-sm-4 col-no-gutter text-align-right">
                                                {" "}
                                                <a onClick={() => removeAccount(subcustomerID)} href="javascript:void(0);" className="default_link">
                                                    <div className="data-value">{"Remove " + member.firstName}</div>
                                                </a>
                                            </div>
                                        )}
                                        {member.cancelDate && (
                                            <div role="gridcell" className="col-xs-6 col-sm-4 col-no-gutter text-align-right">
                                                <div className="data-value">
                                                    <span className="form-error">
                                                        <p>Cancelling on {moment(member.cancelDate).format("MMM D, YYYY")}</p>
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}

                            <div className="margin-top-l"></div>
                            <div role="row">
                                <div role="gridcell">
                                    {showAddFamilyLink && (
                                        <p>
                                            <a onClick={openAddFamilyMemberDialog} href="javascript:void(0);" className="default_link">
                                                <em className="las la-plus"></em> {tLang("manageAccount.myAccount.familyProtection.addFamilyMemberText")}
                                            </a>
                                        </p>
                                    )}
                                </div>    
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <></>
            )}

            {isRemoveAccountDialogVisible && (
                <DialogComponent
                    dialogId="dialog-remove-family-member-account-dialog-idf-family-service"
                    title="Remove Family Member"
                    closeDialog={closeRemoveDialog}
                >
                    <DeleteFamilyAccountDialog subCustomerId={removeAccountSubcustomerID} closeDialog={closeRemoveDialog} />
                </DialogComponent>
            )}

            {isIDFFamilyServiceDialogVisible && (
                <DialogComponent
                    dialogId="dialog-add-family-member-account-dialog-idf-family-service"
                    title="Add Family Member"
                    closeDialog={closeFamilyMemberDialog}
                >
                    <IDFFamilyServiceDialog
                        dialogId="dialog-add-family-member-account-dialog-idf-family-service"
                        history={props.history}
                        closeDialog={closeFamilyMemberDialog}
                    />
                </DialogComponent>
            )}

            {isResendActivationMailDialogVisible && (
                <DialogComponent
                    dialogId="dialog-add-family-member-account-dialog-resend-activation-email"
                    title="Resend activation email"
                    closeDialog={closeResendActivationMailDialog}
                >
                    <ResendActivationMailDialog
                        firstName={resendActivationEmailAccountDetails.firstName}
                        lastName={resendActivationEmailAccountDetails.lastName}
                        email={resendActivationEmailAccountDetails.email}
                        subcustomerId={resendActivationEmailAccountDetails.subcustomerId}
                        closeDialog={closeResendActivationMailDialog}
                    />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default IDFFamilyProtection;
